export default function Badge({ children, variant = 'default' }) {
  const variants = {
    default: 'bg-blue-100 text-blue-700',
    premium: 'bg-amber-100 text-amber-700',
    herbal: 'bg-green-100 text-green-700',
    new: 'bg-rose-100 text-rose-700',
  };

  return (
    <span
      className={`inline-block text-xs font-semibold px-2.5 py-0.5 rounded-full uppercase tracking-wide ${
        variants[variant.toLowerCase()] || variants.default
      }`}
    >
      {children}
    </span>
  );
}
